<template>
	<div>
		<FormGroup
			:state="dateValid"
			class="mt-3"
		>
			<RadioGroup
				v-model="type"
				:options="typeOptions"
				@input="emitChangeEvent"
			/>
			<DatePickerCalendar
				v-if="dateEligible"
				v-model="date"
				:force-min-date="new Date()"
				:years-in-future="2"
				@input="emitChangeEvent"
			/>
			<div v-if="noticePeriodEligible" class="mt-2 d-flex align-items-center">
				<div>Kündigungsfrist beträgt</div>
				<div class="mx-2 w-auto">
					<Select
						v-model="noticePeriod"
						:options="noticePeriodOptions"
						class="w-auto"
						empty-value-label="Monat(e)"
						@input="emitChangeEvent"
					/>
				</div>
				<div>Monat(e)</div>
			</div>
		</FormGroup>
	</div>
</template>
<script>
import FormGroup from "@/vue/common/form/Group";
import {isDefined} from "@/helper/Value";
import DatePickerCalendar from "@/vue/common/form/DatePickerCalendar.vue";
import {DateTime} from "luxon";
import RadioGroup from "@/vue/common/form/RadioGroup.vue";
import Select from "@/vue/common/form/Select.vue";
import _ from "lodash";

const TYPE__IMMEDIATELY = 'immediately';
const TYPE__DATE = 'date';
const TYPE__NOTICE_PERIOD = 'notice-period';

export default {

	components: {
		Select,
		RadioGroup,
		DatePickerCalendar,
		FormGroup,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	mounted ()
	{
		this.emitChangeEvent();
	},

	data ()
	{
		const now = DateTime.now();

		return {
			type: this.value?.type,
			date: this.value?.date || {
				day: now.day,
				month: now.month,
				year: now.year,
			},
			noticePeriod: this.value?.noticePeriod || '',
		};
	},

	computed: {
		typeOptions ()
		{
			return [
				{value: TYPE__IMMEDIATELY, text: 'Ab sofort'},
				{value: TYPE__DATE, text: 'Ab bestimmten Datum'},
				{value: TYPE__NOTICE_PERIOD, text: 'Nach einer bestimmten Kündigungsfrist'},
			];
		},
		noticePeriodEligible ()
		{
			return this.type === TYPE__NOTICE_PERIOD;
		},
		noticePeriodOptions ()
		{
			return _.map(_.range(1, 13, 1), month =>
			{
				return { value: month, text: month };
			});
		},
		dateEligible ()
		{
			return this.type === TYPE__DATE;
		},
		dateValid ()
		{
			return !this.dateEligible || isDefined(this.date);
		},
		noticePeriodValid ()
		{
			return !this.noticePeriodEligible || isDefined(
				_.find(this.noticePeriodOptions, option => option.value === this.noticePeriod)
			);
		},
		dataValid ()
		{
			return isDefined(this.type) && this.dateValid && this.noticePeriodValid;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				type: this.type,
				date: this.dateEligible ? this.date : undefined,
				noticePeriod: this.noticePeriodEligible ? this.noticePeriod : undefined,
			});
		},
	}
}
</script>
